(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || window.__toserofKartPuan) return;
  window.__toserofKartPuan = true;
  var api = (script.dataset.tsyKartApi || '').replace(/\/+$/, '');
  var shop = script.dataset.shop;
  var en = (script.dataset.locale || '').indexOf('en') === 0;
  var locale = en ? 'en-GB' : 'tr-TR';
  var cache = new Map();
  var pending = new Set();
  var timer;
  var selector = '[data-tsy-kart-puan]';
  var star = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5L2.6 9.4l6.5-.9z"/></svg>';

  function draw(node, summary) {
    node.textContent = '';
    node.hidden = true;
    if (!summary || !summary.count || !Number.isFinite(summary.average)) return;
    var rating = summary.average.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    var count = summary.count.toLocaleString(locale);
    node.setAttribute('aria-label', en ? rating + ' out of 5, ' + count + ' ratings' : '5 üzerinden ' + rating + ', ' + count + ' değerlendirme');
    var stars = document.createElement('span');
    stars.className = 'tsy-kart-puan__yildiz';
    stars.setAttribute('aria-hidden', 'true');
    ['bos', 'dolu'].forEach(function (type) {
      var layer = document.createElement('span');
      layer.className = 'tsy-kart-puan__' + type;
      layer.innerHTML = star.repeat(5);
      if (type === 'dolu') layer.style.width = Math.max(0, Math.min(100, summary.average / 5 * 100)) + '%';
      stars.appendChild(layer);
    });
    node.appendChild(stars);
    var value = document.createElement('span');
    value.textContent = rating;
    node.appendChild(value);
    var number = document.createElement('span');
    number.className = 'tsy-kart-puan__adet';
    number.textContent = '(' + count + ')';
    node.appendChild(number);
    node.hidden = false;
  }

  function applyCache() {
    document.querySelectorAll(selector).forEach(function (node) {
      var id = node.dataset.tsyKartPuan;
      if (cache.has(id) && node.dataset.tsyPuanCizildi !== '1') {
        draw(node, cache.get(id));
        node.dataset.tsyPuanCizildi = '1';
      }
    });
  }

  function load(ids) {
    ids.forEach(function (id) { pending.add(id); });
    fetch(api + '/api/reviews/summaries?shop=' + encodeURIComponent(shop) + '&product_ids=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('API'); return response.json(); })
      .then(function (data) {
        if (!data.ok || !data.enabled || !data.summaries) return;
        ids.forEach(function (id) { cache.set(id, data.summaries[id] || { average: null, count: 0 }); });
        applyCache();
      }).catch(function () {}).finally(function () {
        ids.forEach(function (id) { pending.delete(id); });
      });
  }

  function scan() {
    applyCache();
    var ids = new Set();
    document.querySelectorAll(selector).forEach(function (node) {
      var id = node.dataset.tsyKartPuan;
      if (/^\d+$/.test(id) && !cache.has(id) && !pending.has(id)) ids.add(id);
    });
    var list = Array.from(ids);
    for (var i = 0; i < list.length; i += 100) load(list.slice(i, i + 100));
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(scan, 60); }
  function start() {
    if (!api || !shop) return;
    scan();
    new MutationObserver(function (mutations) {
      var cardsAdded = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (cardsAdded) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
